import AWS from 'aws-sdk'
import moment from 'moment'

const BUCKET_NAME = 'habits-game-videos'
const REGION = 'us-east-1'

export type AwsCredentials = any

export async function uploadInspireVideo(
  person: string,
  videoBlob: Blob,
  credentials: AwsCredentials
): Promise<string> {
  AWS.config.update({ ...credentials, region: REGION })

  const s3 = new AWS.S3()

  const convertedBlob = new Blob([videoBlob], { type: 'video/mov' })

  return new Promise((resolve, reject) => {
    const fileName = `${moment().format()}_${person}.mov`
    s3.putObject(
      {
        Bucket: BUCKET_NAME,
        Key: fileName,
        Body: convertedBlob,
        ContentType: 'video/mp4',
        ACL: 'public-read',
      },
      (err) => {
        if (err) {
          reject(err)
        } else {
          resolve(fileName)
        }
      }
    )
  })
}
